import "./Spinner.css";

function Spinner({ style }) {
  return (
    <div className="Spinner__container" style={{ ...style }}>
      <div className="Spinner__loader"></div>
    </div>
  );
}

export default Spinner;
